// components/filtv/useFiltvNowPlaying.js
import { useMemo } from "react";
import useFetch from "./useFetch";
import { FILTV_AD_BEST_URL } from "./filtvConstants";
import { advertisements as demoAds } from "./filtvDemoData";
import { selectAdForChannel } from "./filtvHelpers";

function buildBestAdUrl(lcn, location) {
    if (lcn == null) return null;
    const params = new URLSearchParams({ lcn: String(lcn) });
    if (location.area) params.set("area", location.area);
    if (location.city) params.set("city", location.city);
    if (location.state) params.set("state", location.state);
    if (location.pincode) params.set("pincode", location.pincode);
    return `${FILTV_AD_BEST_URL}?${params.toString()}`;
}

export default function useFiltvNowPlaying(lcn, location = {}) {
    const url = useMemo(
        () => buildBestAdUrl(lcn, location),
        [lcn, location.area, location.city, location.state, location.pincode]
    );
    const { data, loading, error } = useFetch(url, { skip: !url });

    const result = useMemo(() => {
        if (data && typeof data === "object") {
            return { ad: data.ad || null, offAir: Boolean(data.offAir) };
        }
        if (error) {
            const fallbackAd = selectAdForChannel(lcn, demoAds, location);
            return { ad: fallbackAd, offAir: !fallbackAd };
        }
        return { ad: null, offAir: false };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, error, lcn, location.area, location.city, location.state, location.pincode]);

    return { ...result, loading };
}